@if (originQueryResults$ | async; as result) {
<kendo-label text="Origin">
    <kendo-multiselect [data]="result?.data ?? []"
                       [disabled]="isDisabled || result.isLoading"
                       [loading]="result.isLoading"
                       [placeholder]="result.isLoading ? 'Loading' : ''"
                       [virtual]="virtual"
                       [value]="value"
                       (valueChange)="handleValueChange($event)"
                       (blur)="handleBlur()">
    </kendo-multiselect>
</kendo-label>
}
